/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagenomatch3Inputs */

const en_ticketpagenomatch3 = /** @type {(inputs: Ticketpagenomatch3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No order matches your selection.`)
};

const de_ticketpagenomatch3 = /** @type {(inputs: Ticketpagenomatch3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Bestellung passt zu deiner Auswahl.`)
};

/**
* | output |
* | --- |
* | "No order matches your selection." |
*
* @param {Ticketpagenomatch3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagenomatch3 = /** @type {((inputs?: Ticketpagenomatch3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagenomatch3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagenomatch3(inputs)
	return de_ticketpagenomatch3(inputs)
});
export { ticketpagenomatch3 as "ticketPageNoMatch" }